// src/index.js
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Provider } from "react-redux";
import { store, persistor } from "./redux/index";
import { PersistGate } from "redux-persist/integration/react";

// O index.js agora fica muito mais limpo.
// Sua única responsabilidade é montar a estrutura inicial da aplicação.
ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

serviceWorker.unregister();











// import React, { useState, useEffect } from "react";
// import ReactDOM from "react-dom";
// import { BrowserRouter, useLocation } from "react-router-dom";
// import Joyride, { STATUS } from "react-joyride";

// import App from "./App";
// import { tours } from "./tours";

// import * as serviceWorker from "./serviceWorker";
// import { Provider } from "react-redux";
// import { store, persistor } from "./redux/index";
// import { PersistGate } from "redux-persist/integration/react";
// import { tourDashboard} from "./tours/dashboardTour";

// function Root() {
//   const location = useLocation();
//   const [steps, setSteps] = useState([]); // Inicia com o primeiro passo do tour
//   const [runTour, setRunTour] = useState(false);

//   // Ao mudar de rota, carrega steps e dispara tour na primeira visita
//   useEffect(() => {
//     const path = location.pathname;
//     console.log("Current path:", path);
//     // Verifica se há passos de tour para a rota atual
//     const next = tours[path] || [];
//     setSteps(next);
//     if (next.length && !localStorage.getItem(`tourDone:${path}`)) {
//       setRunTour(true);
//     }
//   }, [location.pathname]);

//   // Callback para marcar tour como concluído
//   const handleJoyrideCallback = ({ status }) => {
//     if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
//       setRunTour(false);
//       localStorage.setItem(`tourDone:${location.pathname}`, "true");
//     }
//   };

//   return (
//     <>
//       {/* Ícone de ajuda flutuante */}
//       {steps.length > 0 && (
//         <div
//           style={{
//             position: "fixed",
//             top: 100,
//             right: 20,
//             cursor: "pointer",
//             zIndex: 1000,
//           }}
//           aria-label="Abrir tour"
//           role="button"
//           onClick={() => setRunTour(true)}
//         >
//           <i
//             className="ri-question-line"
//             style={{ fontSize: "36px", color: "#0ad6a0" }}
//           />
//         </div>
//       )}

//       {/* Joyride */}
//       <Joyride
//         steps={steps.map(s => ({ ...s, disableBeacon: true }))}
//         run={runTour}
//         continuous
//         showSkipButton
//         styles={{
//           options: { primaryColor: "#0ad6a0", zIndex: 1000 },
//         }}
//         locale={{
//           skip: "Pular",
//           next: "Próximo",
//           back: "Voltar",
//           last: "Finalizar",
//         }}
//         callback={handleJoyrideCallback}
//       />

//       {/* Sua aplicação */}
//       <App />
//     </>
//   );
// }

// ReactDOM.render(
//   <Provider store={store}>
//     <PersistGate persistor={persistor}>
//       <BrowserRouter>
//         <Root />
//       </BrowserRouter>
//     </PersistGate>
//   </Provider>,
//   document.getElementById("root")
// );

// serviceWorker.unregister();





// import React from "react";
// import ReactDOM from "react-dom";
// import { BrowserRouter } from "react-router-dom"; // Importe o BrowserRouter
// import App from "./App";
// import * as serviceWorker from "./serviceWorker";

// import { Provider } from "react-redux";
// import { store, persistor } from "./redux/index";
// import { PersistGate } from "redux-persist/integration/react";

// ReactDOM.render(
//   <Provider store={store}>
//     <PersistGate persistor={persistor}>
//       <BrowserRouter>
//         <App />
//       </BrowserRouter>
//     </PersistGate>
//   </Provider>,
//   document.getElementById("root")
// );

// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
